import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { connect } from "../../../base/redux";
import { getBaseConfig } from "../../../customise/Utils";
import Button from "@atlaskit/button/standard-button";
import {
  ModalBody,
  ModalHeader,
  ModalTitle,
} from "@atlaskit/modal-dialog";
import ModalDialog from "@atlaskit/modal-dialog";
import { FEATURE_CUSTOM_PAYMENT, FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V3 } from "../../constant";
import {
  getFriendList,
  getInstrumentsList,
  sendEmailInviteFromPopup,
  getMyClaimedRoomsApi,
} from "../../welcome-dashboard/Request.d";
import {
  setShowRtaJamInvitePopup,
  setShowRtaJamEmailInvitePopup,
  setConfirmationModalProps
} from "../../redux/tool-webjam-v3/actions";
import MultipleSelect from "./MultipleSelectOption";
import { hideApiLoader, showApiLoader } from "../../redux/tool-webjam/actions";
import { CURRENT_ROOM_NAME } from "../../../webjam/constant";
import { useDevice } from "../../welcome-dashboard/Utils";
import { Translate } from "../../../webjam/language";
import { CircularProgress } from "@mui/material";
import { checkSubscription, ct } from "../../constant-Utils";
import { handleSubscription } from "./CommonComponents";

function AddRtaJamPeopleDialog(props) {
  const dispatch = useDispatch();
  const { isMobile } = useDevice();
  const InviteMessageLink = `${ct("rta-trmc.rtaInviteModal.joinLink")} ${getBaseConfig("socialReferrerUrl")}/`;

  const [currentPage, setCurrentPage] = useState(1);
  const [showLoader, setShowLoader] = useState(true);
  const [showFilter, setShowFilter] = useState(false); // TODO
  const [showUserWebroomsList, setShowUserWebroomsList] = useState(true);
  const [emailPopUpSuccess, setEmailPopUpSuccess] = useState(false);
  const [fList, setFriendsList] = useState([]);
  const [instrumentGenre, setInstrumentGenre] = useState([]);
  const [selectedInstrumentGenre, setSelectedInstrumentGenre] = useState({});
  const [instrumentLevel, setInstrumentLevel] = useState([]);
  const [selectedInstrumentLevel, setSelectedInstrumentLevel] = useState({});
  const [instrumentList, setInstrumentList] = useState([]);
  const [selectedInstrumentList, setSelectedInstrumentList] = useState([]);
  const [selectedTab, setSelectedTab] = useState("all");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [filters, setFilters] = useState({});
  const [additionalFilters, setAdditionalFilters] = useState({
    is_online: 0,
    jamming_range: 0,
    profile_picture: 0
  });
  const [roomNameList, setRoomNameList] = useState([]);
  const [isEmailNotSent, setIsEmailNotSent] = useState(false);
  const [isFriendsListLoading, setIsFriendsListLoading] = useState(false);
  const [loadMore, setLoadMore] = useState(true);

  const [emailSubject, setEmailSubject] = useState(
    ct("rta-trmc.rtaInviteModal.emailSubject")
  );
  const [emailMessage, setEmailMessage] = useState(InviteMessageLink);

  const setEmailMessageText = (roomName) => {
    // return InviteMessageLink + " " + getBaseConfig("socialReferrerUrl") + "/" + roomName;
    let msgString = emailMessage.split('/webcam/');
    console.log("InviteMessageLink ", { InviteMessageLink }, { emailMessage }, { msgString })

    msgString[msgString.length - 1] = `/webcam/${roomName}`;
    msgString = msgString.join('');

    // console.log("msgString ",msgString)
    return msgString;
  }

  const handleInstrumentList = (e) => {
    try {
      const isSpace = e?.split(" ")?.length > 1;
      let key = e;
      if (isSpace) {
        key = e.replace(/ /g, "_");
      }
      return ct(`rta-trmc.mixer.instrumentList.${key?.toLowerCase()}`);
    } catch (error) {
      return e;
    }

  }

  useEffect(async () => {
    dispatch(showApiLoader());
    const instrumentsList = await getInstrumentsList();
    const getFriendListResponse = await getFriendList(
      selectedTab,
      searchInput,
      1,
      { ...filters, ...additionalFilters }
    );
    dispatch(hideApiLoader());
    // debugger;

    if (getFriendListResponse.friendsList) {
      const { friendsList } = getFriendListResponse;
      setEmailMessage(`${setEmailMessageText(CURRENT_ROOM_NAME)}`);
      setInstrumentGenre(instrumentsList["data"]["instrumentGenre"]);
      setInstrumentLevel(instrumentsList["data"]["instrumentLevel"]);
      setInstrumentList(instrumentsList["data"]["instrumentList"]);
      // setShowFilter(true);
      setFriendsList(friendsList);
      setShowLoader(false);
    }
  }, [selectedTab]);

  useEffect(() => {
    const getData = setTimeout(async () => {
      dispatch(showApiLoader());
      let searchedFriendsList = await getFriendList(
        selectedTab,
        searchInput,
        1,
        { ...filters, ...additionalFilters }
      );
      dispatch(hideApiLoader());
      if (searchedFriendsList.friendsList) {
        const { friendsList } = searchedFriendsList;
        setFriendsList(friendsList);
        setShowLoader(false);
      }
    }, 500);

    return () => clearTimeout(getData);
  }, [searchInput]);

  const handleTabChange = (currentSelection) => {
    setShowLoader(true);
    setSelectedTab(currentSelection);
  };

  const handleUserSelect = () => {
    const selectedUsersName = selectedUsers.filter((u) => u.checked);
    const _selectedUsersName = selectedUsersName.map(e => e.name);
    return _selectedUsersName.toString();
  };

  const handleEmailSend = async () => {
    const haveSubscription = props.isSubscriptionActive;

    if (!haveSubscription) {
      handleSubscription();
      return false;
    }
    event.preventDefault();
    const validSelectedUers = selectedUsers.filter((su) => su.checked == true);

    if (validSelectedUers.length < 0) {
      // alert("Please select a user to send email");
      dispatch(setConfirmationModalProps({
        isShow: true,
        title: ct("Translate.typography.alert"),
        content: ct("Translate.messages.sendEmail"),
        showCancelButton: false,
        cancelBtnName: ct("Translate.buttonTitle.cancelSmall"),
        successBtnName: ct("Translate.buttonTitle.okSmall"),
        onSuccess: () => {
          dispatch(setConfirmationModalProps({ isShow: false }));
        }
      }));

      return false;
    }

    const friendsIdList = validSelectedUers.map((u) => u.id);
    const friendsIdString = friendsIdList.toString();
    const data = {
      friends: friendsIdString,
      subject: emailSubject,
      message: emailMessage,
    };
    const sendEmailResponse = await sendEmailInviteFromPopup(data);

    if (sendEmailResponse.statusCode == 200) {
      setEmailPopUpSuccess(true);
      setTimeout(() => {
        setEmailPopUpSuccess(false);
        dispatch(setShowRtaJamEmailInvitePopup(false));
        dispatch(setShowRtaJamInvitePopup(false));
      }, 3000);
    } else {
      setEmailPopUpSuccess(true);
      setIsEmailNotSent(true);
      setTimeout(() => {
        setEmailPopUpSuccess(false);
        setIsEmailNotSent(false);
      }, 5000);
    }
  };

  const handleEmailSendInitiate = () => {
    setShowUserWebroomsList(true);
    const selectedUsersName = selectedUsers.filter((u) => {
      if (!!u.checked) return u.name;
    });

    if (selectedUsersName.length < 1) {
      // alert("Please select at least one user to invite");
      dispatch(setConfirmationModalProps({
        isShow: true,
        title: ct("Translate.typography.alert"),
        content: ct("Translate.messages.inviteUserError"),
        showCancelButton: false,
        successBtnName: ct("Translate.buttonTitle.okSmall"),
        cancelBtnName: ct("Translate.buttonTitle.cancelSmall"),
        onSuccess: () => {
          dispatch(setConfirmationModalProps({ isShow: false }));
        }
      }));
      return false;
    } else {
      dispatch(setShowRtaJamEmailInvitePopup(true));
    }
  };

  const handleEmailChange = () => {
    setEmailMessage(event.target.value);
  };

  const handleSubjectChange = () => {
    setEmailSubject(event.target.value);
  };

  const enableCheckbox = async (target) => {
    setShowUserWebroomsList(target.checked);
    setEmailMessage(`${setEmailMessageText(CURRENT_ROOM_NAME)}`);
    // fetch room names here
    const _roomNameList = await getMyClaimedRoomsApi();
    // Return control back if no claimed room found
    // and dont set checkbox to checked because no room name found
    if (!_roomNameList.status) return false;

    // update local state for room names
    setRoomNameList(_roomNameList?.data);

    _roomNameList.length > 0 ? setEmailMessage(`${setEmailMessageText(_roomNameList[0].groupName)}`) : null;
  }

  useEffect(() => {
    enableCheckbox({ checked: true });
  }, []);

  const handleCheckboxChange = async () => {
    const target = event.target;

    if (target.getAttribute("id") == "incudeInviteCheckbox") {
      enableCheckbox(target);
      return;
    }
    //prepare checked user list object
    const userChecked = {
      id: target.getAttribute("id"),
      name: target.getAttribute("name"),
      checked: target.checked,
    };

    // get all users except current user
    const getAllExceptCurrent = selectedUsers.filter(
      (u) => u.id != target.getAttribute("id")
    );
    setSelectedUsers([...getAllExceptCurrent, userChecked]);
  };

  const onRoomNameSelectHandler = () => {
    const target = event.target;
    if (target.value) {
      setEmailMessage(`${setEmailMessageText(target.value)}`);
    }
  };

  const getUserCheckedStatus = (userId) => {
    return selectedUsers.find((u) => u.id == userId && u.checked == true);
  };

  const handleGenereChange = (value, type) => {
    setSelectedInstrumentGenre({ ...selectedInstrumentGenre, [type]: value });
  };

  const handleInstrumentChange = (value, type) => {
    setSelectedInstrumentList(value);
  };

  const handleLevelChange = (id) => {
    const target = event.target;

    setSelectedInstrumentLevel({
      ...selectedInstrumentLevel,
      [`instrument_level[${id}]`]: target.value,
    });
  };

  const getInstrumentValueByName = (name) => {
    const instrumentDetail = instrumentList.filter((inst) => inst.name == name);
    return instrumentDetail[0]?.value;
  };

  const getGenereValueByName = (name) => {
    const genereDetail = instrumentGenre.filter((inst) => inst.name == name);
    return genereDetail[0]?.value;
  };

  const prepareData = () => {
    let filters1 = {};

    for (let key in selectedInstrumentGenre) {
      selectedInstrumentGenre[key].map((g, index) => {
        filters1 = {
          ...filters1,
          [`${key}[${index}]`]: getGenereValueByName(g),
        };
      });
    }

    selectedInstrumentList.map((i, indexI) => {
      filters1 = {
        ...filters1,
        [`instrument_name[${indexI}]`]: getInstrumentValueByName(i),
      };
    });

    for (let key in selectedInstrumentLevel) {
      filters1 = {
        ...filters1,
        [key]: selectedInstrumentLevel[key],
      };
    }

    setFilters(filters1);
    dispatch(showApiLoader());
    if (showFilter) {
      setShowFilter(!showFilter);
    }
    setTimeout(async () => {
      let searchedFriendsList = await getFriendList(
        selectedTab,
        searchInput,
        1,
        { ...filters1, ...additionalFilters }
      );
      dispatch(hideApiLoader());
      if (searchedFriendsList.friendsList) {
        const { friendsList } = searchedFriendsList;
        setFriendsList(friendsList);
      }
    }, 1000);
  };

  const ListSelectedInstrumentFilter = () => {
    return selectedInstrumentList.map((instrument, index) => {
      return (
        <div className="selected-instrument-wrapper" key={index}>
          <div className="selected-instrument-heading">{handleInstrumentList(instrument)}</div>
          <div className="selected-genere-level">
            <span>{ct("rta-trmc.rtaInviteModal.selectGenre")}:</span>
            <MultipleSelect
              key={index}
              options={instrumentGenre}
              name={`instrument_genre`}
              onChange={handleGenereChange}
              value={[]}
              parent={getInstrumentValueByName(instrument)}
            />
          </div>

          <div className="selected-instrument-level">
            <span>{ct("rta-trmc.rtaInviteModal.selectLevel")}:</span>
            <select
              className="instrument_level"
              onChange={() =>
                handleLevelChange(getInstrumentValueByName(instrument))
              }
            >
              <option value="">{ct("rta-trmc.rtaInviteModal.selectLevel")}</option>
              {instrumentLevel &&
                instrumentLevel.map((IL, ILIndex) => (
                  <option
                    key={ILIndex}
                    value={IL.value}
                    data-id={ILIndex}
                    name={`instrument_level[${getInstrumentValueByName(
                      instrument
                    )}]`}
                  >
                    {handleInstrumentList(IL.name)}
                  </option>
                ))}
            </select>
          </div>
        </div>
      );
    });
  };

  const clearFilters = async () => {

    setAdditionalFilters({
      is_online: 0,
      jamming_range: 0,
      profile_picture: 0
    })
    setFilters({});
    setSelectedInstrumentGenre({});
    setSelectedInstrumentLevel({});
    setSelectedInstrumentList([]);

    // refresh invite list 

    dispatch(showApiLoader());
    const getFriendListResponse = await getFriendList(
      selectedTab,
      searchInput,
      1,
      {}
    );
    dispatch(hideApiLoader());
    if (getFriendListResponse.friendsList) {
      const { friendsList } = getFriendListResponse;
      setFriendsList(friendsList);
    }
    setLoadMore(true);
  };

  const handleScroll = async () => {
    if (!loadMore) {
      return false;
    }
    const bottom = Math.floor(event.target.scrollHeight) - (Math.floor(event.target.scrollTop)) >= Math.floor(event.target.clientHeight);

    if (bottom && !isFriendsListLoading) {
      if (!isFriendsListLoading) {
        setIsFriendsListLoading(true);
      }

      let searchedFriendsList = await getFriendList(
        selectedTab,
        searchInput,
        currentPage + 1,
        { ...filters, ...additionalFilters }
      );

      setCurrentPage(currentPage + 1);
      setIsFriendsListLoading(false);
      if (searchedFriendsList.friendsList) {
        const { friendsList } = searchedFriendsList;
        if (friendsList?.length === 0) {
          setLoadMore(false);
        }
        setFriendsList([...fList, ...friendsList]);
      }
    }
  };

  const updateFriendsList = (fList) => {
    if (fList.length < 1 && !showLoader)
      return (
        <li className="list-group-item" key="0">
          <label
            className="container custom-no-result"
            style={{ maxWidth: "50vh" }}
          >
            {ct("Translate.typography.noRecordFound")}
          </label>
        </li>
      );

    return fList.map((f, index) => {
      return (
        <li className={`list-group-item ${fList?.length - 1 === index && isFriendsListLoading ? 'last-li-child' : ''}`} key={f.userId}>
          <label className="">
            <span>
              <input
                className="list-group-item_container_check-box"
                type="checkbox"
                aria-label={f.name}
                name={f.name}
                id={f.userId}
                onChange={() => handleCheckboxChange()}
                checked={getUserCheckedStatus(f.userId)}
              />
            </span>
            <span>
              <a
                href={f.profile_url}
                target="_blank"
                className="list-group-item_container_profile-url"
              >
                <img
                  onError={(e) => {
                    e.target.src = getBaseConfig('defaultUserImage');
                  }}
                  src={f.image_url}
                  alt={f.name}
                  className="list-group-item_container_img"
                />
              </a>
            </span>
            <span>
              <div>{f.name} {f.is_online != 0 ? <a className="blink blink-icon" title="Online"><i className="fa fa-circle blink-icon" aria-hidden="true" style={{ fontSize: "x-small" }}></i></a> : null}</div>
              <div>
                {f.friend_count} {ct("rta-trmc.rtaInviteModal.friends")}, {f.photo_count} {ct("rta-trmc.rtaInviteModal.photos")} {f.jamming_range != 0 ? <>, <span className={f.jamming_range < 800 ? 'jam-range-lt800' : 'jam-range-gt800'}></span> {f.jamming_range < 800 ? `500 ${ct("rta-trmc.rtaInviteModal.miles")}` : `1000 ${ct("rta-trmc.rtaInviteModal.miles")}`}</> : null}
              </div>
            </span>
          </label>
        </li>
      );
    });
  };

  useEffect(() => {
    setEmailMessage(`${setEmailMessageText(CURRENT_ROOM_NAME)}`);
  }, [props.showRtaJamEmailInvitePopup])

  return (
    <>
      {/* <Dialog
			disableAutoHideOnSubmit={true}
			disableBackdropClose={true}
			hideCloseButton={false}
			onCancel={() => dispatch(setShowRtaJamInvitePopup(false))}
			// onSubmit={() => submit()}
			cancel={{hidden:true}}
			ok={{hidden:true}}
			titleKey={"Invite"}
			rtaClassName="invite-jam-partner-dialog"
      testId="rta-jam-modal-popup"
			> */}
      <ModalDialog
        shouldScrollInViewport={false}
        className="rta-jam-modal-popup"
        width={"large"}
        testId="rta-jam-modal-popup"
      >
        <ModalHeader className="rta-jam-modal-popup_header">
          <ModalTitle>{ct("rta-trmc.rtaInviteModal.invite")}</ModalTitle>
          <Button
            appearance="link"
            onClick={() => dispatch(setShowRtaJamInvitePopup(false))}
          >
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAJqADAAQAAAABAAAAJgAAAACnOgJhAAABb0lEQVRYCb3YAY6CMBAFUOMJuIEewZvJjeRIewO8gdwA/+92dhOiZdrOZ5IJSKr/UaQaTifUuq539Ix+oR/ogcePKGblTGbP6HvKxc6I3hYH3dQwZqCZta2RszVvj+bXUhwyvqEYPxO2cO9LSXDIKqFIWQibuFeoUBxy9lCkTIQN6B++KlQIDp/vQdHye/NxBy3FVaPszlPimlFKXDdKgQtDReLCURE4GaoHJ0e14A5DNeC4EJfqf/G0D+/dIs2zCB+LspPqwMXPlKFs24DToxpwzaizhVVurxh/cbyHYzhWX7iUN/Te3YchfxXyl6l4ZoiqRZlOh+tA6XBOFL/o7FLFzRxSPJePoCG3HleDsi+nHNeCkuN6UDJcBCocF4kKwylQ3TglqhkHFNefvd++tE5ZSOs2Z3nWucHzUCUEZSfjxKWHKqXZCkVV4F6csSf6U0lQTtyTsPGDSopy4MY0JuM4cwt6Qh/9cJiZzKYhod4LGG8hUxJjfAAAAABJRU5ErkJggg==" />
          </Button>
        </ModalHeader>
        <ModalBody className="rta-jam-modal-popup_body">

          <div className="row1">
            <div className="colmd-4">
              <div className="filterWrapper d-block">
                {/* {showFilter && ( */}
                <div
                  className={`instrumentFilters ${showFilter ? "filter-open" : ""
                    }`}
                >
                  <div className="instrument-filters-inner">
                    <div className="additional-filters-wrapper">
                      <div className="additional-filters">
                        <input
                          className="list-group-item_container_check-box"
                          type="checkbox"
                          aria-label="Is Online"
                          id="is_online"
                          checked={additionalFilters.is_online}
                          onChange={() => setAdditionalFilters({ ...additionalFilters, is_online: additionalFilters.is_online ? 0 : 1 })}
                        />
                        <label for="is_online">{ct("rta-trmc.rtaInviteModal.isOnline")}</label>
                      </div>
                      <div className="additional-filters">
                        <input
                          className="list-group-item_container_check-box"
                          type="checkbox"
                          aria-label="Jamming Range"
                          id="jamming_range"
                          checked={additionalFilters.jamming_range}
                          onChange={() => setAdditionalFilters({ ...additionalFilters, jamming_range: additionalFilters.jamming_range ? 0 : 1 })}
                        />
                        <label for="jamming_range">{ct("rta-trmc.rtaInviteModal.jammingRange")}</label>
                      </div>
                      <div className="additional-filters">
                        <input
                          className="list-group-item_container_check-box"
                          type="checkbox"
                          aria-label="Profile Picture"
                          id="profile_picture"
                          checked={additionalFilters.profile_picture}
                          onChange={() => setAdditionalFilters({ ...additionalFilters, profile_picture: additionalFilters.profile_picture ? 0 : 1 })}
                        />
                        <label for="profile_picture">{ct("rta-trmc.rtaInviteModal.profilePicture")}</label>
                      </div>
                    </div>
                    <span style={{ paddingLeft: "0px" }}>
                      {ct("rta-trmc.rtaInviteModal.selectInstruments")}:
                    </span>
                    <div className="rta-jam-popup-instrument-list">
                      {instrumentList.length > 0 && (
                        <MultipleSelect
                          key={`Instrument${instrumentList.length}`}
                          options={instrumentList}
                          name="Instrument"
                          onChange={handleInstrumentChange}
                          clearFiltersCB={clearFilters}
                          placeholder={"Select instrument"}
                        />
                      )}
                      <div className="filters-wrapper">
                        {ListSelectedInstrumentFilter()}
                      </div>
                    </div>





                  </div>

                  <div className="instrument-filter-button-wrapper">
                    <button onClick={() => {
                      if (showFilter) {
                        setShowFilter(!showFilter);
                      }
                      setLoadMore(true);
                      document.getElementById('instrument-clear-control').click();
                    }}>
                      {ct("rta-trmc.rtaInviteModal.clear")}
                    </button>

                    <button onClick={() => {
                      prepareData();
                      setLoadMore(true);
                    }}>
                      {ct("rta-trmc.rtaInviteModal.search")}
                    </button>
                  </div>

                </div>

                {/* )} */}

                <div className="filterClose">
                  <i
                    className="fa fa-sliders pointer "
                    aria-hidden="true"
                    onClick={() => setShowFilter(!showFilter)}
                  ></i>
                </div>
              </div>
            </div>
            <div className={`colmd-8 pt-2 ${showFilter ? 'show-filter-hide-div' : ''}`} >
              <div className="row11">
                <div className="col11-md-6">
                  <span
                    className={`${selectedTab == "all" ? "active" : ""}`}
                    key="all"
                    onClick={() => handleTabChange("all")}
                  >
                    {ct("rta-trmc.rtaInviteModal.everyone")}
                  </span>
                  <span
                    className={`${selectedTab == "friends" ? "active" : ""}`}
                    key="friends"
                    onClick={() => handleTabChange("friends")}
                  >
                    {ct("rta-trmc.rtaInviteModal.myFriends")}
                  </span>
                </div>
                <div className="col11-md-6 col11-sm-6">
                  <div className="tabs-filter-search">
                    <input
                      className="search-input"
                      type="search"
                      placeholder={ct("rta-trmc.rtaInviteModal.search")}
                      value={searchInput}
                      onChange={(event) => setSearchInput(event.target.value)}
                    />

                  </div>
                </div>
              </div>
              <div className="row22">
                <div className="col22-md-12 margin-bottom-mobile-only loaderWrapperforList">
                  <ul
                    className="list-group list-group-light"
                    id="list-group-friend-list"
                    onScroll={handleScroll}
                  >
                    {/* {showLoader && (
                      <div className="spinnerWrapper">
                        <i className="fa fa-spinner" aria-hidden="true"></i>
                      </div>
                    )} */}
                    {updateFriendsList(fList)}
                    {isFriendsListLoading && <li className="friend-loader-li"><CircularProgress /></li>}
                  </ul>
                </div>
                <div className="col22-md-12 margin-top-mobile-only">

                  <div className="instrument-filter-button-wrapper invite-btn-wrap">
                    <button onClick={() => handleEmailSendInitiate()}>
                      {ct("rta-trmc.rtaInviteModal.sendMsg")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </ModalDialog>
      {/* </Dialog> */}
      {props.showRtaJamEmailInvitePopup && (
        // <Dialog
        // disableAutoHideOnSubmit={true}
        // disableBackdropClose={true}
        // hideCloseButton={false}
        // onCancel={() => dispatch(
        //   setShowRtaJamEmailInvitePopup(false),
        //   setShowUserWebroomsList(false)
        // )}
        // cancel={{hidden:true}}
        // ok={{hidden:true}}
        // titleKey={"Invite"}
        // rtaClassName="rta-jam-email-modal-dialog"
        // testId="rta-jam-email-modal-popup"
        // >
        <ModalDialog
          shouldScrollInViewport={false}

          width={"large"}
          className="rta-jam-email-modal-popup"
          testId="rta-jam-email-modal-popup"
        >
          <ModalHeader className="rta-jam-email-modal-popup_header">
            <ModalTitle>
              {!emailPopUpSuccess
                ? ct("rta-trmc.rtaInviteModal.emailInvitation")
                : isEmailNotSent ? ct("rta-trmc.rtaInviteModal.failInvitation") : ct("rta-trmc.rtaInviteModal.invitationSent")}
            </ModalTitle>
            {!emailPopUpSuccess && (
              <Button
                appearance="link"
                onClick={() =>
                  dispatch(
                    setShowRtaJamEmailInvitePopup(false),
                    setShowUserWebroomsList(false)
                  )
                }
              >
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAJqADAAQAAAABAAAAJgAAAACnOgJhAAABb0lEQVRYCb3YAY6CMBAFUOMJuIEewZvJjeRIewO8gdwA/+92dhOiZdrOZ5IJSKr/UaQaTifUuq539Ix+oR/ogcePKGblTGbP6HvKxc6I3hYH3dQwZqCZta2RszVvj+bXUhwyvqEYPxO2cO9LSXDIKqFIWQibuFeoUBxy9lCkTIQN6B++KlQIDp/vQdHye/NxBy3FVaPszlPimlFKXDdKgQtDReLCURE4GaoHJ0e14A5DNeC4EJfqf/G0D+/dIs2zCB+LspPqwMXPlKFs24DToxpwzaizhVVurxh/cbyHYzhWX7iUN/Te3YchfxXyl6l4ZoiqRZlOh+tA6XBOFL/o7FLFzRxSPJePoCG3HleDsi+nHNeCkuN6UDJcBCocF4kKwylQ3TglqhkHFNefvd++tE5ZSOs2Z3nWucHzUCUEZSfjxKWHKqXZCkVV4F6csSf6U0lQTtyTsPGDSopy4MY0JuM4cwt6Qh/9cJiZzKYhod4LGG8hUxJjfAAAAABJRU5ErkJggg==" />
              </Button>
            )}
          </ModalHeader>
          <ModalBody className="rta-jam-email-modal-popup_body">
            {!emailPopUpSuccess ? (
              <form className="rta-jam-email-modal-popup_body_form">
                <div className="form-group row">
                  <label for="staticEmail" className="col-sm-2 col-form-label">
                    {ct("rta-trmc.rtaInviteModal.to")}
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="text"
                      // readonly
                      disabled
                      className="form-control-plaintext"
                      id="staticEmail"
                      value={handleUserSelect()}
                    />
                  </div>
                </div>
                {props.userLoginData.isRoomClaimed && <div className="form-group row">
                  <div className="col-md-8 col-sm-8 d-flex align-items-center">
                    <input
                      type="checkbox"
                      className="form-control mb-0"
                      id="incudeInviteCheckbox"
                      checked={(showUserWebroomsList)}
                      onChange={() => {
                        handleCheckboxChange()
                      }}
                    />
                    <label for="incudeInviteCheckbox" className="col-form-label">
                      {ct("rta-trmc.rtaInviteModal.includeInvite")}
                    </label>
                  </div>
                  {(showUserWebroomsList) && (
                    <div className="col-md-4 col-sm-4 text-right">
                      <select
                        className={`rta-jam-email-modal-popup_body_form_selectbox claimed-room-select ${isMobile ? "claimed-room-select-width" : ""}`}
                        onChange={() => onRoomNameSelectHandler()}
                      >
                        <option value="">{ct("rta-trmc.rtaInviteModal.selectRoom")}</option>
                        {roomNameList.length > 0 ? (
                          roomNameList.map((rn) => {
                            // if(rn.groupName == CURRENT_ROOM_NAME){
                            //   if(!isClaimedRoom){
                            //     setIsClaimedRoom(true);
                            //   }
                            // }
                            return (
                              <option key={rn._id} value={rn.groupName} selected={rn.groupName == CURRENT_ROOM_NAME}>
                                {rn.groupName}
                              </option>
                            )
                          })
                        ) : (
                          <option>{ct("rta-trmc.rtaInviteModal.noRoomFound")}</option>
                        )}
                      </select>
                    </div>
                  )}
                </div>}
                <div className="form-group row">
                  <label for="emailSubject" className="col-sm-2 col-form-label">
                    {ct("rta-trmc.rtaInviteModal.subject")}
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control"
                      id="emailSubject"
                      placeholder="Subject"
                      value={!showUserWebroomsList ? "" : emailSubject}
                      onChange={() => handleSubjectChange()}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label for="emailMessage" className="col-sm-2 col-form-label">
                    {ct("rta-trmc.rtaInviteModal.message")}
                  </label>
                  <div className="col-sm-10">
                    <textarea
                      className="form-control"
                      id="emailMessage"
                      rows="3"
                      value={!showUserWebroomsList ? "" : emailMessage}
                      onChange={() => handleEmailChange()}
                    ></textarea>
                  </div>
                </div>
                {/* <div className="form-group row">
                  <div className="col-md-8 col-sm-8 d-flex align-items-center">
                    <input
                      type="checkbox"
                      className="form-control mb-0"
                      id="incudeInviteCheckbox"
                      checked={showUserWebroomsList}
                      onChange={() => handleCheckboxChange()}
                    />
                    <label for="incudeInviteCheckbox" className="col-form-label">
                      Include invite to your webcam room
                    </label>
                  </div>
                  {showUserWebroomsList && (
                    <div className="col-md-4 col-sm-4 text-right">
                      <select
                        className={`rta-jam-email-modal-popup_body_form_selectbox claimed-room-select ${isMobile ? "claimed-room-select-width" : ""}`}
                        onChange={() => onRoomNameSelectHandler()}
                      >
                        <option value="">Select Room</option>
                        {roomNameList.length > 0 ? (
                          roomNameList.map((rn) => (
                            <option key={rn._id} value={rn.groupName}>
                              {rn.groupName}
                            </option>
                          ))
                        ) : (
                          <option>No Room Found</option>
                        )}
                      </select>
                    </div>
                  )}
                </div> */}
              </form>
            ) : (
              <div
                className={
                  isEmailNotSent ? `invite-sent-error` : `invite-sent-success`
                }
              >
                {isEmailNotSent
                  ? ct("rta-trmc.rtaInviteModal.somethingWentWrong")
                  : ct("rta-trmc.rtaInviteModal.invitationSend")}
              </div>
            )}

            {!emailPopUpSuccess && (
              <div className="instrument-filter-button-wrapper">
                <button onClick={() => handleEmailSend()}>
                  {ct("rta-trmc.rtaInviteModal.sendMsg")}
                </button>
              </div>
            )}
          </ModalBody>
        </ModalDialog>
      )}
    </>
  );
}

function mapStateToProps(state) {
  return {
    showRtaJamEmailInvitePopup:
      state[FEATURE_CUSTOM_REDUX_V3].showRtaJamEmailInvitePopup,
    userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
    isSubscriptionActive: checkSubscription(),
  };
}

export default connect(mapStateToProps)(AddRtaJamPeopleDialog);
